import React from 'react';
import classnames from 'classnames';

import type INavigationLink from '../../../../../../interfaces/navigation-link';
import useStore from '../../../../../../store';
import Link from '../../../../../link';

import styles from './pages.module.css';

import { useLoaderContext } from '~/providers/loader-context';

interface IProps {
  pages: INavigationLink[];
}

const Pages: React.FC<IProps> = ({ pages = [] }) => {
  const { DISABLE_ODDS_FORMAT_SELECTION } = useLoaderContext();

  const freeBetsCount = useStore((state) => state.config.freeBetsCount);

  return (
    <div
      data-testid="pages"
      className={classnames(
        styles.pages,
        DISABLE_ODDS_FORMAT_SELECTION ? styles.noOddsFormatSelection : ''
      )}>

			{pages.map(({ isSelected, text, url }) =>
      <Link
        data-testid="page-link"
        className={classnames(styles.page, isSelected ? styles.selected : '')}
        to={url}
        key={text}>

					{text}
					{(url === 'free-bets' || url === 'bonus-bets') && freeBetsCount ?
        <span className={styles.offerCount}>{freeBetsCount}</span> :
        null}
				</Link>
      )}
		</div>);

};

export default Pages;